export function normalizedSettings(settings) {
  const result = JSON.parse(JSON.stringify(settings));
  const ids = result.rows.map(row => row.id);
  result.matrix = Object.fromEntries(ids.map((source, i) => [source,
    Object.fromEntries(ids.map((target, j) => [target,
      i < j ? (result.matrix?.[source]?.[target] ?? null) : null,
    ])),
  ]));
  return result;
}

export function initialBudgetSettings(settings, terms) {
  if (settings.rows.length) return normalizedSettings(settings);
  const names = ['А15', 'А7', 'А3'];
  const days = [15, 7, 3];
  const limits = ['5000000.00', '2000000.00', '500000.00'];
  return normalizedSettings({ ...settings, rows: days.map((day, i) => ({
    id: `00000000-0000-0000-0000-${String(day).padStart(12, '0')}`,
    name: names[i], limit: limits[i],
    payment_term_id: terms.find(term => term.name.trim().toUpperCase() === `${day} БД`)?.id ?? null,
  })) });
}

export function availableSources(period, paymentTermId) {
  if (!period) return [];
  const target = period.settings.rows.find(row => row.payment_term_id === Number(paymentTermId));
  if (!target) return [];
  return period.settings.rows.filter(row => row.id === target.id
    || period.settings.matrix?.[row.id]?.[target.id] != null);
}

export function advanceOperationChoices(period, kind, sourceId, day = new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Moscow' })) {
  const empty = reason => ({ reason, sources: [], targets: [], sourceId: '' });
  if (!period || period.status !== 'ACTIVE') return empty('no_period');
  if (period.ends_on < day) return empty('expired');
  const rows = period.settings?.rows || [];
  if (!rows.length) return empty('no_budgets');
  if (kind === 'replenishments') return { reason: null, sources: [], targets: rows, sourceId: '' };
  const permittedTargets = source => rows.filter((target, index) =>
    index > rows.findIndex(row => row.id === source.id)
      && Number(period.settings.matrix?.[source.id]?.[target.id]) > 0);
  const sources = rows.filter(row => permittedTargets(row).length > 0);
  if (!sources.length) return empty('no_transfers');
  const source = sources.find(row => row.id === sourceId) || sources[0];
  return { reason: null, sources, targets: permittedTargets(source), sourceId: source.id };
}

export function monthEndInput(now = new Date()) {
  const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return `${last.getFullYear()}-${String(last.getMonth() + 1).padStart(2, '0')}-${String(last.getDate()).padStart(2, '0')}`;
}

export function advanceError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => {
    const path = Array.isArray(item.loc) ? item.loc.filter(part => part !== 'body').join('.') : '';
    return path ? `${path}: ${item.msg}` : item.msg;
  }).join('; ');
  return error?.message || 'Ошибка операции';
}

export const transactionNames = {
  INITIAL: 'Начальное выделение', INITIAL_TOTAL: 'Общий лимит', OPEN_PERIOD: 'Создание периода',
  PAYMENT: 'Списание за рейс', TRANSFER: 'Перевод', REPLENISH: 'Пополнение', COMPENSATION: 'Отмена',
};
